import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import moment from 'moment';
import { Button, F } from 'components/Ui';
import { Slide } from '@material-ui/core';
import ThumbUpGreen from 'images/ThumbUpGreen.svg';
import { useIsVertPhone } from 'utils/hooks';
import { dataLayerPush } from 'utils/tracking';

import styles from './styles.scss';

const EditingDeliveryOrderDrawer = ({
  shopDeliveryOrder,
  onConfirm,
  section,
}) => {
  const isVertPhone = useIsVertPhone();
  const drawerRef = useRef();
  const deliveryDate =
    shopDeliveryOrder && moment(shopDeliveryOrder.date).format('MM/DD/YY');

  useEffect(() => {
    if (drawerRef.current && shopDeliveryOrder) {
      drawerRef.current.focus();
    }
  }, [shopDeliveryOrder, document.activeElement]);

  const message = isVertPhone
    ? `Editing`
    : `You are editing your delivery scheduled for`;

  return (
    <Slide direction="up" in={!!shopDeliveryOrder} mountOnEnter unmountOnExit>
      <div className={styles.modal} ref={drawerRef} tabIndex="-1">
        <img src={ThumbUpGreen} alt="" />
        <div
          className={classnames(styles.text, isVertPhone && styles.textPhone)}
        >
          <F>{message}</F> {deliveryDate}
        </div>
        <Button
          text="View Order"
          className={styles.confirmButton}
          onClick={(e) => {
            onConfirm(e);
            dataLayerPush(
              'SelfServe',
              {
                event: 'view-order',
                date: moment(deliveryDate).format('YYYY-MM-DD'),
                section,
              },
              'dlS5',
            );
          }}
        />
      </div>
    </Slide>
  );
};

EditingDeliveryOrderDrawer.propTypes = {
  section: PropTypes.string.isRequired,
  shopDeliveryOrder: PropTypes.object.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default EditingDeliveryOrderDrawer;
